var React = require('react');

function Mug (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 64h-32v288-32h32a128 128 0 0 0 0-256zm0 192h-32V128h32a64 64 0 0 1 0 128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 352a96 96 0 0 1-96 96H128a96 96 0 0 1-96-96V87.88A23.94 23.94 0 0 1 56 64h360v288z","className":"fa-primary","key":2})]);
}

Mug.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Mug;

Mug.default = Mug;
